import {
  N_CampaignTemplateListViewItem,
  activeArchivedTabs,
  templateStatus,
} from "@specsheet-common/shared-types";

export const archivedCampaignTemplateTabIndex =
  activeArchivedTabs.indexOf("Archived");

export const isArchivedCampaignTemplateTab = (tabIndex: number): boolean =>
  tabIndex === archivedCampaignTemplateTabIndex;

export const isActiveCampaignTemplate = (template: {
  status: N_CampaignTemplateListViewItem["status"];
  isActive: boolean;
}): boolean => template.status === templateStatus.Active && template.isActive;

/** Same rule as list checkboxes: system templates cannot be selected/archived. */
export const isSelectableCampaignTemplate = (template: {
  isSystem: boolean;
}): boolean => !template.isSystem;

export const isDeletableCampaignTemplate = (template: {
  isSystem: boolean;
  status: N_CampaignTemplateListViewItem["status"];
  isActive: boolean;
}): boolean =>
  isSelectableCampaignTemplate(template) && isActiveCampaignTemplate(template);

/**
 * Edit-panel delete matches list archive: never show for system/default templates.
 * Edit drawer only opens for active templates, so isSystem is the gate.
 */
export const canDeleteCampaignTemplateFromEdit = (template: {
  isSystem: boolean;
}): boolean => isSelectableCampaignTemplate(template);

export const isRestorableCampaignTemplate = (template: {
  isSystem: boolean;
  status: N_CampaignTemplateListViewItem["status"];
  isActive: boolean;
}): boolean =>
  isSelectableCampaignTemplate(template) && !isActiveCampaignTemplate(template);

export const sortCampaignTemplateListItems = (
  templates: N_CampaignTemplateListViewItem[]
): N_CampaignTemplateListViewItem[] =>
  [...templates].sort((left, right) => {
    if (left.isSystem && !right.isSystem) {
      return -1;
    }
    if (!left.isSystem && right.isSystem) {
      return 1;
    }
    return left.label.localeCompare(right.label);
  });

export const filterCampaignTemplatesByActiveArchivedTab = (
  templates: N_CampaignTemplateListViewItem[],
  currentTab: number
): N_CampaignTemplateListViewItem[] =>
  templates.filter((template) =>
    currentTab === 0
      ? isActiveCampaignTemplate(template)
      : !isActiveCampaignTemplate(template)
  );

export const getActiveCampaignTemplates = (
  templates: N_CampaignTemplateListViewItem[]
): N_CampaignTemplateListViewItem[] =>
  sortCampaignTemplateListItems(
    templates.filter((template) => isActiveCampaignTemplate(template))
  );
